"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhaetonRescue = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
class PhaetonRescue {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.PHAETON_RESCUE;
        this.description = 'Gain 1 steel for every 2 building tags (max 5 sets) and influence. Decrease all colony tracks 1 step.';
        this.revealedDelegate = PartyName_1.PartyName.BUREAUCRATS;
        this.currentDelegate = PartyName_1.PartyName.SPOME;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const tagCount = Math.min(Math.floor(player.getTagCount(Tags_1.Tags.BUILDING, 'raw') / 2), 5) + turmoil.getPlayerInfluence(player);
            if (tagCount > 0)
                player.addResource(Resources_1.Resources.STEEL, tagCount, { log: true });
        });
        game.colonies.forEach((colony) => {
            colony.decreaseTrack();
        });
    }
}
exports.PhaetonRescue = PhaetonRescue;
//# sourceMappingURL=PhaetonRescue.js.map